import React from "react"

import WPImage, { DISPLAY_MODE } from "../_base/WPImage"
import WPCta from "../_base/WPCta"

import InvitationOnly from "./InvitationOnly"

import * as registerNowStyles from "../../styles/world_championships/RegisterNow.module.css"

const RegisterNow = props => {
  const { content } = props

  return (
    <div id="register-now" className="container-fluid">
      <div className={`row ${registerNowStyles.wrapper}`}>
        <div className="col">
          <div style={{ display: "grid", gridAutoRows: "1fr" }}>
            <div
              style={{
                gridArea: "1/1",
                position: "relative",
                placeItems: "left",
                display: "grid",
                zIndex: 2,
              }}
            >
              <div className={`row g-0`}>
                <div className={`col-12 ${registerNowStyles.content}`}>
                  <div className={`row g-0`}>
                    <div className={`col-12 ${registerNowStyles.logoWrapper}`}>
                      <h1>Upcoming Events 2025</h1>
                    </div>
                  </div>
                  <div className={`row g-0`}>
                    <div className={`col-12 ${registerNowStyles.tableWrapper}`}>
                      <table className={`table ${registerNowStyles.table}`}>
                        <thead>
                          <tr>
                            <th scope="col">Event</th>
                            {/* <th scope="col">City</th> */}
                            <th scope="col">Date</th>
                            <th scope="col">Register</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            {/* <th scope="row">Online Qualifier Registration</th>
                            <td>Online</td> 
                            <td>Jun 27</td>
                            <td>
                              <a href="">Register</a>
                            </td> */}
                          </tr>
                          <tr className={`${registerNowStyles.colored}`}>
                            <th scope="row">APAC Qualifier Online </th>
                            {/* <td>Online</td> */}
                            <td>Aug 5</td>
                            <td className={`${registerNowStyles.button}`}>
                              <a href="https://events.teams.microsoft.com/event/5accee5c-e232-49ca-afa2-82db5fa03d0b@0635d657-0279-4110-9c8f-2ee27b1e065b">
                                Register
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">EMEA Qualifier Online</th>
                            {/* <td>Online</td> */}
                            <td>Aug 7</td>
                            <td className={`${registerNowStyles.button}`}>
                              <a href="https://events.teams.microsoft.com/event/f34b1a86-af02-4455-bf00-3ee5129dd5e1@0635d657-0279-4110-9c8f-2ee27b1e065b">
                                Register
                              </a>
                            </td>
                          </tr>
                          <tr className={`${registerNowStyles.colored}`}>
                            <th scope="row">North America Qualifier Online</th>
                            {/* <td>Online</td> */}
                            <td>Aug 14</td>
                            <td className={`${registerNowStyles.button}`}>
                              <a href="https://events.teams.microsoft.com/event/7a609c7b-1ee5-4056-a440-72427612f05e@0635d657-0279-4110-9c8f-2ee27b1e065b">
                                Register
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">APAC Semi-finals Online</th>
                            {/* <td>Orlando</td> */}
                            <td>Aug 21</td>
                            <td className={`${registerNowStyles.button}`}>
                              <a
                                href="#!"
                                onClick={evt => {
                                  evt.preventDefault()
                                  const tr =
                                    evt.target.closest("tr").nextElementSibling
                                  tr.style.display =
                                    tr.style.display === "none"
                                      ? "table-row"
                                      : "none"
                                }}
                              >
                                Invite Only
                              </a>
                            </td>
                          </tr>
                          <tr
                            className={`${registerNowStyles.invitationOnly}`}
                            style={{ display: "none" }}
                          >
                            <td colSpan={3}>
                              <InvitationOnly
                                airtableToken={process.env.GATSBY_AIRTABLE_API_TOKEN}
                                airtableBaseId={'appoE3nlX6zL5jsX4'}
                                airtableTableName={'Invitations'}
                              />
                            </td>
                          </tr>
                          <tr className={`${registerNowStyles.colored}`}>
                            <th scope="row">EMEA Semi-finals Online</th>
                            {/* <td></td> */}
                            <td>Aug 29</td>
                            <td className={`${registerNowStyles.button}`}>
                           
                            <a
                                href="#!"
                                onClick={evt => {
                                  evt.preventDefault()
                                  const tr =
                                    evt.target.closest("tr").nextElementSibling
                                  tr.style.display =
                                    tr.style.display === "none"
                                      ? "table-row"
                                      : "none"
                                }}
                              >
                                Invite Only
                              </a>
                            </td>
                          </tr>
                          <tr
                            className={`${registerNowStyles.colored} ${registerNowStyles.invitationOnly}`}
                            style={{ display: "none" }}
                          >
                              <td colSpan={3}>
                                <InvitationOnly
                                  airtableToken={process.env.GATSBY_AIRTABLE_API_TOKEN}
                                  airtableBaseId={'appoE3nlX6zL5jsX4'}
                                  airtableTableName={'Invitations'}
                                />
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">
                              North America Semi-finals at the IBM Planning
                              Analytics Community Day
                            </th>
                            {/* <td>Orlando</td> */}
                            <td>Oct 6</td>
                            <td className={`${registerNowStyles.button}`}>
                              {
                                <a href="https://reg.tools.ibm.com/flow/ibm/techxchange25/sessioncatalog/page/sessioncatalog ">
                                  Register
                                </a>
                              }
                            </td>
                          </tr>
                          <tr className={`${registerNowStyles.colored}`}>
                            <th scope="row">
                              TM1 World Championship Final on the Main Stage at
                              IBM TechXchange 2025
                            </th>
                            {/* <td></td> */}
                            <td>Oct 9</td>
                            <td className={`${registerNowStyles.button}`}>
                              {
                                <a href="https://reg.tools.ibm.com/flow/ibm/techxchange25/sessioncatalog/page/sessioncatalog">
                                  Register
                                </a>
                              }
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`${registerNowStyles.backgroundContainmentImage}`}
              style={{
                gridArea: "1/1",
                objectFit: "cover",
                placeItems: "right",
                zIndex: 1,
              }}
              objectfit="cover"
              placeholderstyle={{
                objectFit: `cover`,
                objectPosition: `right bottom`,
              }}
              imgstyle={{
                objectFit: `cover`,
                objectPosition: `right bottom`,
              }}
              transformoptions={{ fit: "cover" }}
            >
              <WPImage
                holder={content}
                selector={`media-asset`}
                mode={DISPLAY_MODE.normal}
                className={`d-none d-lg-flex ${registerNowStyles.backgroundImage}`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RegisterNow
